
export const Error = () => {
  return (
    <div style={{backgroundColor:"gray",color:"white",width:"300px",height:"300px"}}>404 Error - Page not found</div>
  )
}
